import request from '@/utils/request'

export function getListHotel(query) {
  return request({
    url: '/config-service/v1/hotel/hotel',
    method: 'get',
    params: query
  })
}

export function getHotelInfoById(id) {
  return request({
    url: `/config-service/v1/hotel/hotel/${id}`,
    method: 'get'
  })
}

export function getAllHotel() {
  return request({
    url: '/config-service/v1/hotel/hotel/all',
    method: 'get'
  })
}

export function deleteHotel(data) {
  return request({
    url: '/config-service/v1/hotel/hotel',
    method: 'delete',
    data: data
  })
}
